import { z } from "zod";
import {
  engagementTypeList,
  functionAreaList,
  industryList,
  stageList,
} from "@/redux/features/candidateProfileSlice";

const schema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  companyDescription: z.string().optional(),
  otherIndustries: z.string().optional(),
  jobTitle: z.string().min(1, "Job title is required"),
  engagementType: z.enum(engagementTypeList).optional(),
  functions: z.enum(functionAreaList).array().optional(),
  location: z.string().optional(),
  startDate: z.date().nullable().optional(),
  endDate: z.date().nullable().optional(),
  outcomes: z.string().optional(),
  industries: z.enum([...industryList, "Other"]).optional(),
  stage: z.enum(stageList).optional(),
  companyLogo: z.instanceof(File).optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateExperienceFormSchema,
  type Schema as CandidateExperienceFormSchema,
};
